<template>
  <div class="page-organization">
    <item-title :title="{name: '机构分布', en_1: 'BRANCHES', en_2: ''}" />
    <div class="filter-block clearfix">
      <div class="area-filter ">
        <div class="area-category">
          <div class="btn-select-group">
             <span class="btn" :class="{active:queryForm.rkeyword===item}" v-for="(item,index) in regionData" :key="index" @click="regionChange(item,index)">{{item}}</span>
            <!-- <span class="btn" :class="{active:queryForm.rkeyword===item.name}" v-for="(item,index) in regionData" :key="item.name" @click="regionChange(item,index)">{{item.name}}</span> -->
          </div>
        </div>
        <div class="area-sub-category">
          <div class="btn-select-group-2">
            <!-- <span class="btn" :class="{active:queryForm.keyword===item.name}" v-for="item in provinceData" :key="item.name" @click="provinceChange(item)">{{item.name}}</span> -->
            <span class="btn" :class="{active:queryForm.keyword===item}" v-for="item in provinceData" :key="item" @click="provinceChange(item)">{{item}}</span>
          </div>
        </div>
      </div>
      <div class="keyword-filter">
        <div class="split-vertical-line"></div>
        <search :value.sync="keyword" @search="inputChange" @input="input" placeholder="城市名称"></search>
      </div>

    </div>

    <div class="area-filter-result clearfix custom-scroll-bar">
      <div class="company-list-container">
        <div class="company" v-for="(item) in companyData" :key="item.id" :class="{'company_department': item.name.indexOf('营业部') > -1}" @click="selectCompany(item)">
          <div class="name"> {{item.name}}</div>
          <div class="address">
            <img src="@/assets/img/contactus/location_gray.png" />
            <div>{{item.address}}</div>
          </div>
          <div class="phone">
            <img src="@/assets/img/contactus/phone.png" />
            {{item.phone||'暂未公示'}}
          </div>
        </div>
      </div>
      <!-- <section class="map-container">
        <home-map ref="map" :companyData="companyData" />
      </section> -->
    </div>
  </div>
</template>

<script>
// import HomeMap from '@/components/contactUs/Map.vue'
import ItemTitle from '@/components/common/itemTitle'
import search from '@/components/contactUs/search'
import geoCoordMap from '@/helper/geoCoordMap'
// import regionData from '@/helper/regionData'
import {
  getOrgans,
  getRegions,
  getProvince
} from '@/api/contactUs'
export default {
  components: {
    ItemTitle,
    // HomeMap,
    search
  },
  data() {
    return {
      // regionData: regionData,
      regionData: [],
      provinceData: [],
      companyData: [],
      queryForm: {
        keyword: '',
        rkeyword: ''
      },
      keyword: '',
      currentCompanyId: ''
    }
  },
  computed: {
    // provinceData() {
    //   let index = this.regionData.findIndex(item => item.name === this.queryForm.rkeyword)
    //   if (index > -1) {
    //     return this.regionData[index].options || []
    //   }
    //   return []
    // }
  },
  created() {
    let keywords = this.$route.query.keywords
    if (keywords) {
      this.keyword = keywords
      this.input()
    }
    this.getData()
    this.getRegions()
  },
  methods: {
    // 获取大区数据
    async getRegions () {
      let res = await getRegions()
      this.regionData = res
      // this.queryForm.rkeyword = res[0]
      let res1 = await getProvince({region: res[0]})
      // this.queryForm.keyword = res1[0]
      this.provinceData = res1
      this.search()
    },
    // 获取页面数据
    async getData() {
      let params = Object.assign({}, {
        ...this.queryForm,
      })
      if (params.rkeyword === '总部') {
        params.rkeyword = ''
      }
      if (this.keyword) {
        params.rkeyword = ''
        this.queryForm.rkeyword = ''
        params.keyword = this.keyword
        
      }
      params.page = 1
      params.limit = 1000
      let res = await getOrgans(params)
      if (params.rkeyword == '北区') {
        this.companyData = res.records.filter(item => {return item.id != 86}) || []
      } else {
        this.companyData = res.records
      }
      let data = this.convertData(this.companyData)
      let paleData = this.paleData = ((geoCoordMap, data) => {
        let arr = []
        let len = data.length
        while (len--) {
          let geoCoord = geoCoordMap[data[len].name]
          if (geoCoord) {
            let obj = {
              name: data[len].name,
              id: data[len].id,
              value: geoCoord.concat(data[len].value)
            }
            if ((data[len].name || '').includes('北京')) {
              obj.symbolSize = 18;
              obj.symbol = 'image://data:image/png;base64,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'
            }
            arr.push(obj)
          }
        }
        return arr
      })(geoCoordMap, data)
      if (this.$refs['map']) {
        this.$refs['map'].setOption(paleData)
      }
      this.$emit('loading', false)
    },
    convertData(data) {
      return data.map(item => ({
        name: item.city,
        id: item.id,
        value: {
          companyName: item.name,
          address: item.address,
          phone: item.phone
        }
      }))
    },
    async regionChange(item) {
      if (this.queryForm.rkeyword === item) {
        this.queryForm.rkeyword = ''
        this.queryForm.keyword = ''
      } else {
        this.queryForm.rkeyword = item
        // this.queryForm.keyword = this.regionData[index].options[0]
        let res = await getProvince({region: item})
        // console.log(res)
        this.queryForm.keyword = res[0]
        this.provinceData = res
        this.keyword = ''
      }
      this.search()
    },
    provinceChange(item) {
      if (this.queryForm.keyword === item) {
        this.queryForm.keyword = ''
      } else {
        this.queryForm.keyword = item
        this.keyword = ''
      }
      this.search()
    },
    search() {
      this.getData()
    },
    input() {
      if (this.keyword) {
        this.queryForm.keyword = ''
        this.queryForm.rkeyword = ''
      }
    },
    inputChange() {
      if (this.keyword) {
        this.queryForm.keyword = ''
        this.queryForm.rkeyword = ''
      }
      this.search()
    },
    selectCompany(company) {
      this.currentCompanyId = company.id
      let dataIndex = this.paleData.findIndex(item => item.id === company.id);
      if (this.$refs['map']) {
        this.$refs['map'].showTip(dataIndex, this.paleData)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-box .page-organization {
  overflow: visible;
  max-width: pxToRem(1100);
}
.page-organization {
  .area-filter {
    padding: pxToRem(36) 0 pxToRem(22) 0;
    float: left;
  }
  ::v-deep .common-search {
    float: right;
    width: pxToRem(270);
  }
  .keyword-filter {
    padding: pxToRem(36) 0 pxToRem(22) 0;
  }
  .area-filter-result {
    position: relative;
    margin: pxToRem(30) 0 0;
    height: pxToRem(800);
    background-size: auto 100%;
    overflow: auto;
    padding: 0 0.17rem;
    .company-list-container {
      width: 100%;
      color: #999;
      font-size: 0.16rem;
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .company {
        width: 100%;
        padding: 0.16rem 0.24rem 0.16rem 0.24rem;
        box-shadow: 0px 0px 0.17rem 0px rgba(0,0,0,0.17);
        border-radius: 0.12rem;
        margin-top: 0.1rem;
        cursor: pointer;
        .name {
          font-size: 0.18rem;
          color: #FF6002;
          line-height: 0.25rem;
        }
        img {
          width: 0.14rem;
          margin-right: 0.05rem;
          vertical-align: middle;
        }
        .address {
          font-size: 0.16rem;
          line-height: 0.22rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0.1rem 0;
          color: #888;
          div {
            flex: 1;
            max-width: calc(100% - 0.2rem);
          }
        }
        .phone {
          display: flex;
          align-items: center;
          font-size: 0.16rem;
          line-height: 0.22rem;
          color: #888;
        }
      }
      .company_department{
        width: 49.3%;
        border: none;
        background: #F7F7F7;
        box-shadow: none;
        .name {
          color: #333;
        }
        img {
          width: 0.14rem;
          margin-right: 0.05rem;
          vertical-align: middle;
        }
        .address {
          color: #888;
        }
        .phone {
          color: #888;
        }
      }
    }
    .map-container {
      position: relative;
      float: left;
      width: percentage(740/1080);
      height: pxToRem(588);
      padding: pxToRem(22) pxToRem(28);
    }
  }
}
@media only screen and (max-width: 992px) {
  .page-organization {
    .area-filter-result {
      .company-list-container {
        width: 100%;
        height: auto;
      }
      .map-container {
        width: 100%;
      }
    }
  }
}

.btn-select-group-2 {
  .btn {
    position: relative;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    padding: 0;
    margin-right: pxToRem(40);
    margin-bottom: pxToRem(10);
    font-size: pxToRem(16);
    border: none;
    &.active,
    &:hover {
      color: $orange;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: $orange;
      }
    }
  }
}
@media only screen and (max-width: $moble_width) {
  .page-organization {
    .split-vertical-line {
      display: none;
    }
    .common-search {
      width: 100%;
    }
    .area-filter-result {
      margin-top: 0.4rem;
      height:auto;
      padding-bottom: 0.17rem;
      .company_department{
        width: 100% !important;
        margin-right:0 !important;
      }
    }
  }
}
</style>